var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashiconsAdminTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8492 12.2125C20.0559 13.0076 19.0445 13.5495 17.9432 13.7698C16.8418 13.99 15.6998 13.8788 14.6617 13.45L7.89922 21.6C6.66172 22.8375 4.66172 22.8375 3.42422 21.6C2.18672 20.3625 2.18672 18.3625 3.42422 17.1375L11.5742 10.3625C10.7242 8.30002 11.1367 5.85002 12.8117 4.17502C14.4117 2.57502 16.7117 2.15002 18.7117 2.85002L15.0992 6.46252L18.6242 9.98752L22.1992 6.40002C22.8617 8.37502 22.4242 10.6375 20.8492 12.2125ZM4.76172 20.2625C5.26172 20.75 6.06172 20.75 6.54922 20.2625C7.04922 19.7625 7.04922 18.9625 6.54922 18.475C6.06172 17.975 5.26172 17.975 4.76172 18.475C4.52735 18.7135 4.39602 19.0344 4.39602 19.3688C4.39602 19.7031 4.52735 20.0241 4.76172 20.2625Z",
    fill: "#041018"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsAdminTools);
export default __webpack_public_path__ + "static/media/dashicons_admin-tools.9db607d6.svg";
export { ForwardRef as ReactComponent };